import { Link } from 'react-router';
import { cn } from '../../../components/ui';
import { useStaff } from '../../../lib/auth';
import { statusText, useLiveEvents } from '../../../lib/live';

/**
 * Top-bar live indicator. Mounting it keeps this tab's live stream open on every screen, which is what makes
 * every open screen update by itself. Green and pulsing while connected; grey when the screens are refreshing
 * on their own timers instead. Opens the live activity feed.
 */
export function LiveDot({ className }: { className?: string }) {
  const { me } = useStaff();
  const { status } = useLiveEvents(me.user.id);
  const live = status === 'live';
  return (
    <Link
      to="/admin/live-activity"
      title={statusText(status)}
      aria-label={`Live activity. ${statusText(status)}`}
      className={cn('flex h-11 w-11 shrink-0 items-center justify-center rounded-lg hover:bg-slate-100 sm:h-9 sm:w-auto sm:gap-1.5 sm:px-2', className)}
    >
      <span className="relative flex h-2.5 w-2.5" aria-hidden>
        {live && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75 motion-reduce:animate-none" />}
        <span className={cn('relative inline-flex h-2.5 w-2.5 rounded-full', live ? 'bg-emerald-500' : status === 'reconnecting' || status === 'connecting' ? 'bg-amber-400' : 'bg-slate-300')} />
      </span>
      <span className={cn('hidden text-xs font-medium sm:inline', live ? 'text-emerald-700' : 'text-slate-500')} aria-hidden>
        Live
      </span>
    </Link>
  );
}

export default LiveDot;
